export const oAuth2AuthErrorMessageKind = "oauth2-auth-error";
